// App Types
export enum AppType {
  LEGACY = 'LEGACY',
  HAUSARZT = 'HAUSARZT',
  KINDERARZT = 'KINDERARZT'
}

export enum Zeitslot {
  VORMITTAG = 'VORMITTAG',
  NACHMITTAG = 'NACHMITTAG'
}

export interface ArztPraxis {
  arztId: number;
  praxisId: number;
  arbeitstage: string[];
  praxis?: Praxis;
}

export interface Arzt {
  id: number;
  vorname: string;
  nachname: string;
  qualifikation?: string;
  email?: string;
  telefon?: string;
  apps?: AppType[];
  praxisAssociations?: ArztPraxis[];
  // Legacy support for older components temporarily (optional)
  praxen?: Praxis[];
  arbeitstage?: string[];
  createdAt: Date;
  updatedAt: Date;
}

export interface Praxis {
  id: number;
  name: string;
  strasse?: string;
  plz?: string;
  stadt?: string;
  telefon?: string;
  email?: string;
  type?: AppType;
  createdAt: Date;
  updatedAt: Date;
}

export interface Feiertag {
  id: number;
  datum: string | Date;
  name?: string;
  typ: string; // 'GANZTAGS', 'VORMITTAG', 'NACHMITTAG'
  createdAt: Date;
  updatedAt: Date;
}

export interface CreateFeiertagDTO {
  datum: string | Date;
  name?: string;
  typ: string;
}

export interface Zuweisung {
  id: number;
  arztId: number;
  praxisId: number;
  datum: Date;
  zeitslot: Zeitslot;
  notizen?: string;
  createdAt: Date;
  updatedAt: Date;
  arzt?: Arzt;
  praxis?: Praxis;
}

export interface ZuweisungFilter {
  arztId?: number;
  praxisId?: number;
  startDatum?: Date;
  endDatum?: Date;
  zeitslot?: Zeitslot;
}

export interface ConflictCheckResult {
  hasConflict: boolean;
  conflictingZuweisungen?: Zuweisung[];
}

export interface ErrorResponse {
  error: string;
  message: string;
  details?: any;
  statusCode: number;
}

export interface ConflictErrorResponse extends ErrorResponse {
  error: 'CONFLICT';
  conflictingAssignments: Array<{
    id: number;
    praxisName: string;
    datum: string;
    zeitslot: Zeitslot;
  }>;
}

// Authentication Types
export enum UserRole {
  ADMIN = 'ADMIN',
  MANAGER = 'MANAGER',
  DOCTOR = 'DOCTOR'
}

export interface User {
  id: number;
  username: string;
  role: UserRole;
  allowedApps?: AppType[];
  createdAt: Date;
  updatedAt: Date;
}

export interface LoginCredentials {
  username: string;
  password: string;
}

export interface LoginResponse {
  token: string;
  user: User;
}

export interface AuthContextType {
  user: User | null;
  token: string | null;
  login: (credentials: LoginCredentials) => Promise<void>;
  logout: () => void;
  isAuthenticated: boolean;
  isAdmin: boolean;
  isManager: boolean;
  isDoctor: boolean;
  canEdit: boolean;
}

export interface Abwesenheit {
  id: number;
  arztId: number;
  startDatum: Date;
  endDatum: Date;
  typ: string;
  notizen?: string;
  createdAt: Date;
  updatedAt: Date;
  arzt?: Arzt;
}
export interface CreateArztDTO {
  vorname: string;
  nachname: string;
  qualifikation?: string;
  email?: string;
  telefon?: string;
  apps?: AppType[];
  associations: {
    praxisId: number;
    arbeitstage: string[];
  }[];
}

export interface UpdateArztDTO extends Partial<CreateArztDTO> { }
export interface CreateAbwesenheitDTO {
  arztId: number;
  startDatum: Date;
  endDatum: Date;
  typ?: string;
  notizen?: string;
  force?: boolean;
}
export interface CreatePraxisDTO {
  name: string;
  strasse?: string;
  plz?: string;
  stadt?: string;
  telefon?: string;
  email?: string;
  type?: AppType;
}

export interface UpdatePraxisDTO extends Partial<CreatePraxisDTO> { }
